module.exports = __webpack_public_path__ + "img/logo_clock.5d94bfa1.svg";